<template>
  <div
    id="modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    @keyup.enter="yes"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Fechar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">{{ config.title }}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <form>
              <div class="col-md-12">
                <p>
                  <span
                    v-for="sentence in sentences"
                    :key="sentence.id"
                    :style="
                      sentence && sentence.bold ? 'font-weight: bold' : ''
                    "
                  >
                    {{ sentence.message }}
                  </span>
                </p>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <botao
            v-if="config.showNo !== false"
            estilo="cheio-cinza"
            icone="cancela-modal"
            dismiss="modal"
            :rotulo="config.labelNo"
            @clicado="no()"
          >
          </botao>
          <botao
            estilo="cheio-verde"
            icone="ok-modal"
            :rotulo="config.labelYes"
            @clicado="yes()"
          >
          </botao>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Botao from '@/components/botao';

export default {
  name: 'Modal',
  data() {
    return {
      sentences: [],
      config: {},
    };
  },
  methods: {
    confirm(sentences, config = {}) {
      this.sentences = sentences;
      config.title = config.title ? config.title : 'Alerta';
      config.labelYes = config.labelYes ? config.labelYes : 'Sim';
      config.labelNo = config.labelNo ? config.labelNo : 'Não';
      config.showNo = config.showNo !== undefined ? config.showNo : true;

      this.config = config;

      jQuery('#modal').modal({
        backdrop: config.showNo === false ? 'static' : true,
        keyboard: config.showNo === false ? false : true,
        show: true,
      });
    },
    yes() {
      jQuery('#modal').modal('hide');
      if (this.config.yes) {
        this.config.yes();
      }
    },
    no() {
      if (this.config.no) {
        this.config.no();
      }
    },
  },
  components: {
    botao: Botao,
  },
};
</script>

<style>
.fade {
  z-index: 2200;
}
.modal {
  z-index: 2300;
}
</style>



// WEBPACK FOOTER //
// index.vue?fed46bd0